import {
  ClinicOwnerCurrentSubscriptionResponseDto,
  ClinicOwnerUpdatePurchasedSubscriptionDto,
  CustomerPaymentMethodDto,
} from '@docbay/schemas';

import axiosInstance from 'integration/api/axiosInstance';
import axiosAuthInstance from './axiosAuthInstance';

/**
 * An API client for interacting with clinic owner subscriptions.
 */
export const ClinicOwnerSubscriptionAPI = {
  /**
   * Retrieves the current subscription information for a clinic owner.
   *
   * @returns A promise that resolves to a
   *          `ClinicOwnerCurrentSubscriptionResponseDto` object containing the
   *          subscription information.
   */
  getCurrentSubscription: () => {
    return axiosInstance.get<ClinicOwnerCurrentSubscriptionResponseDto>(
      '/clinic-owner-subscriptions/current',
    );
  },

  /**
   * Updates the current subscription for a clinic owner.
   *
   * @param data - An object containing the new subscription information to be
   *               applied.
   *
   * @returns A promise that resolves to a
   *          `ClinicOwnerCurrentSubscriptionResponseDto` object containing the
   *          updated subscription information.
   */
  updateCurrentSubscription: (
    data: ClinicOwnerUpdatePurchasedSubscriptionDto,
  ) => {
    return axiosInstance.patch<ClinicOwnerCurrentSubscriptionResponseDto>(
      '/clinic-owner-subscriptions',
      data,
    );
  },

  /**
   * Retrieves the payment methods available to a clinic owner.
   *
   * @returns A promise that resolves to an array of
   *          `CustomerPaymentMethodDto` objects, each representing a payment method.
   */
  getPaymentMethods: () => {
    return axiosInstance.get<CustomerPaymentMethodDto[]>(
      '/clinic-owner/payment-methods',
    );
  },

  /**
   * Sets the default payment method for a clinic owner.
   *
   * @param paymentMethodId - The ID of the payment method to be set as the default.
   *
   * @returns A promise that resolves when the default payment method has been
   *          successfully updated.
   */
  setDefaultPaymentMethod: (paymentMethodId: string) => {
    return axiosInstance.post(
      `/clinic-owner/payment-methods/${paymentMethodId}/default`,
    );
  },
  getClinicOwnerSubscriptionsDetails: (token: string) => {
    return axiosAuthInstance(token).post('/clinic-owner-subscriptions/details');
  },

  /**
   * Canceled Subscription Plan.
   */
  cancelSubscriptionPlan: () => {
    return axiosInstance.post('/clinic-owner-subscriptions/cancel');
  },
};
